/**
 * src/hooks/useRadarCa.js
 * React Query v5 del radar de CA.
 *
 * ⚠️ SIN `refetchInterval`, al contrario que prospección: aquí no hay nada que
 * avance mientras miras. El barrido y las listas se generan de noche, así que un
 * refresco periódico solo gastaría peticiones y haría parpadear la tabla. Si
 * algún día esta pantalla dispara un barrido (paso 3), ESE caso sí lo necesita.
 */
import { useQuery } from '@tanstack/react-query'

import { getRadarCaLista, getRadarCaTenant, getRadarCaTenants } from '../api/radarCa'

export function useRadarCaTenants() {
  return useQuery({
    queryKey: ['radar-ca', 'tenants'],
    queryFn: getRadarCaTenants,
  })
}

// El perfil + las noches de un tenant. Las pestañas «Perfil» y «Noches» llaman a
// este mismo hook con los mismos argumentos, asi que React Query lo resuelve con UNA
// peticion y no con dos.
export function useRadarCaTenant(clienteId, { titulos = true, noches = 30 } = {}) {
  return useQuery({
    queryKey: ['radar-ca', 'tenant', clienteId, titulos, noches],
    queryFn: () => getRadarCaTenant(clienteId, { titulos, noches }),
    enabled: Boolean(clienteId),
  })
}

// `enabled` por el clienteId: la lista solo se pide cuando hay una fila abierta.
// Sin esto se pediría la de `undefined` al pintar la tabla.
export function useRadarCaLista(clienteId, { dia = null, gris = false } = {}) {
  return useQuery({
    queryKey: ['radar-ca', 'lista', clienteId, dia, gris],
    queryFn: () => getRadarCaLista(clienteId, { dia, gris }),
    enabled: Boolean(clienteId),
  })
}
